import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class FluxJumpInstruction extends Instruction<"flux-jump"> {
  readonly type = "flux-jump";

  act(context: ProgramModel) {
    context.cursorIndex += context.flux;
  }
}
